import React, { useEffect, useState } from 'react';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { GetNewsItemStatisticsResponse, NewsItemModel } from '../../../../api-service/clients';
import { NewsStatisticsDialogComponent } from './news-statistics-dialog-component';

const client = moduleClientFactory.createForumCaseworkerClient();

export interface INewsStatisticsDialogProps {
  newsItem: NewsItemModel;
  onClose: () => void;
}

export function NewsStatisticsDialog(props: INewsStatisticsDialogProps) {
  const { newsItem, onClose } = props;
  const [statistics, setStatistics] = useState<GetNewsItemStatisticsResponse>();
  const [hasFailed, setHasFailed] = useState(false);

  useEffect(() => {
    async function loadStatistics() {
      try {
        setStatistics(await client.getNewsItemStatistics({ newsItemId: newsItem.id }));
      } catch {
        setHasFailed(true);
      }
    }

    loadStatistics();
  }, [newsItem.id]);

  return <NewsStatisticsDialogComponent title={newsItem.title} statistics={statistics} hasFailed={hasFailed} onClose={onClose} />;
}
